export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_FAIL = 'REQUEST_FAIL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const closeModal = () => async dispatch => {
  return dispatch({
    type: CLOSE_MODAL
  });
};

export const openErrorModal = message => async dispatch => {
  return dispatch({
    type: REQUEST_FAIL,
    message
  });
};
